module.exports = __webpack_public_path__ + "static/media/salary-other.bb5f6688.svg";